/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  teal_10: '#e6faf7',
  teal_20: '#bcf7ee',
  teal_30: '#8df0de',
  teal_40: '#5ee6cd',
  teal_50: '#34d1b7',
  teal_60: '#20baa3',
  teal_70: '#15a18e',
  teal_80: '#0f8c7c',
  teal_90: '#0c7567',
  teal_100: '#0a6358',

  a11y_text_light: [90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/teal.js